import { render, staticRenderFns } from "./FloristReviews.vue?vue&type=template&id=fbb29894"
import script from "./FloristReviews.vue?vue&type=script&lang=js"
export * from "./FloristReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports